export enum DoorStatusTypeEnum {
    Unknown = -1,
    Closed = 0,
    Open = 1,
}

export function doorStatusEnumLabel(status: DoorStatusTypeEnum): string {
    switch (status) {
        case DoorStatusTypeEnum.Closed:
            return "enum.doorStatus.closed";
        case DoorStatusTypeEnum.Open:
            return "enum.doorStatus.open";
        default:
            return "common.unknown";
    }
}